export default __webpack_public_path__ + "static/media/Blog3.94da50b9.png";